module.exports = __webpack_public_path__ + "stylesheets/success-stories-list-item_80d603430e001c20dd6e6085ab65adb6.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/success-stories-list-item.less
// module id = 2SnN
// module chunks = 118